import type { Tone } from "@web-ui/types/tone";

/*
 * StatusDot: a small round dot in a tone with its meaning spoken (`label`), for a row whose state is
 * the point (a protection on or off, an editor item live or hidden), owner 2026-10-13. Styles in
 * styles/data-display.css .status-dot.
 */
type StatusDotProps = {
    className?: string;
    tone: Tone;
    label: string;
};

const StatusDot = ({ className, tone, label }: StatusDotProps) => (
    <span className={`status-dot ${className || ""}`} data-tone={tone} role="img" aria-label={label} />
);

export default StatusDot;
